module.exports = __webpack_public_path__ + "img/15.9ee79833.jpg";